import React, { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserViewQuery, useGetPolicyQuery, useUpdateGroupMutation, useDeleteGroupMutation } from '../../../services/dvagent';
import { Toaster } from '../attributes';
import { getToken, storeAdmin, getUsername } from '../../../services/LocalStorageService';

const commonBorderStyle = {
  border: '1px solid #ccc',
  borderRadius: '10px',
  padding: '10px',
  height: '250px',
  overflowY: 'auto',
};

const listHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const listItemStyle = {
  margin: '2px',
  padding: '4px',
  borderRadius: '4px',
  border: '1px solid #ededed',
  cursor: 'move',
  backgroundColor: 'white',
};

const searchInputStyle = {
  margin: '10px 0',
  padding: '2%',
  width: '70%',
  border: '1px solid #ededed',
  borderRadius: '5px',
};

function formatDate(dateString) {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  });
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });
  return `${formattedDate} ${formattedTime} `;
}

const List = ({
    name,
    items,
    selectedItems,
    searchQuery,
    searchQuery1,
    handleDragStart,
    handleDropItems,
    filteredItems,
    filteredSelectedItems,
    onSearchQueryChange,
    onSearchQuery1Change,
  }) => {
      const handleDragOver = (e) => {
        e.preventDefault();
    };

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div
        onDragOver={handleDragOver}
        onDrop={(e) => handleDropItems(e, 'available')}
        style={{
          ...commonBorderStyle,
          flex: 1,
        }}
      >
        <div style={{ ...listHeaderStyle, position: 'sticky', top: -10, zIndex: 1, background: '#F9FAFB' }}>
          <strong style={{ color: "#B7B7B7", fontStyle: "italic", marginLeft: "10%" }}>{name}</strong>
          <input
            type="text"
            placeholder="Search items"
            value={searchQuery}
            onChange={onSearchQueryChange}
            style={searchInputStyle}
          />
        </div>

        {filteredItems
          .filter((item) => !filteredSelectedItems.some((selectedItem) => selectedItem.id === item.id))
          .map((item) => (
            <div
              key={item.id}
              draggable
              onDragStart={(e) => handleDragStart(e, item)}
              style={listItemStyle}
            >
              <Checkbox value={item.id} onChange={(e) => handleDropItems(e, 'selected')}  />
              {item.email} {item.name}
            </div>
          ))}
      </div>
      <div
        onDragOver={handleDragOver}
        onDrop={(e) => handleDropItems(e, 'selected')}
        style={{
          ...commonBorderStyle,
          marginLeft: '20px',
          flex: 1,
        }}
      >
        <div style={{ ...listHeaderStyle, position: 'sticky', top: -10, zIndex: 1, background: '#F9FAFB' }}>
          <strong style={{ color: "#B7B7B7", fontStyle: "italic", marginLeft: "10%" }}>Picked</strong>
          <input
            type="text"
            placeholder="Search items"
            value={searchQuery1}
            onChange={onSearchQuery1Change}
            style={searchInputStyle}
          />
        </div>

        {filteredSelectedItems.map((item) => (
          <div
            key={item.id}
            draggable
            onDragStart={(e) => handleDragStart(e, item)}
            style={{
              ...listItemStyle,
              backgroundColor: '#ccc',
            }}
          ><Checkbox checked value={item.id} onChange={(e) => handleDropItems(e, 'available')}/>
            {item.email} {item.name}
          </div>
        ))}
      </div>
    </div>
  );
};

const Update = (group) => {

  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [groupName, setGroupName] = useState('');
  const [groupNameError, setGroupNameError] = useState('');
  const [policyListError, setPolicyListError] = useState('');
  const [userListError, setUserListError] = useState('');

  const [confirmAction, setConfirmAction] = useState("");
  const [confirmActionError, setConfirmActionError] = useState("");

  const [open, setOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupLogo, setPopupLogo] = useState('');
  const [popupWidth, setPopupWidth] = useState(0);
  const [askUpdatePopup, setAskUpdatePopup] = useState(false);
  const [askDeletePopup, setAskDeletePopup] = useState(false);

  const [policy, setPolicy] = useState([]);
  const [selectedPolicy, setSelectedPolicy] = useState([]);
  const [searchPolicyQuery, setSearchPolicyQuery] = useState('');
  const [searchPolicyQuery1, setSearchPolicyQuery1] = useState('');

  const [user, setUser] = useState([])
  const [selectedUser, setSelectedUser] = useState([]);
  const [searchUserQuery, setSearchUserQuery] = useState('');
  const [searchUserQuery1, setSearchUserQuery1] = useState('');

  const [buttonLabel, setButtonLabel] = useState("UPDATE");
  const [UpdateGroupMutation] = useUpdateGroupMutation();
  const [DeleteGroupMutation] = useDeleteGroupMutation();
  const { data: userData, isSuccess: userIsSuccess, error: userError } = useUserViewQuery({"token":getToken(), "location":location});
  const { data: policyData, isSuccess: policyIsSuccess, error: policyError } = useGetPolicyQuery({"token":getToken(), "location":location});
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  const filteredPolicy = policy.filter((policy) =>
    policy.name.toLowerCase().includes(searchPolicyQuery.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const filteredSelectedPolicy = selectedPolicy.filter((policy) =>
    policy.name.toLowerCase().includes(searchPolicyQuery1.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const filteredUser = user.filter((user) =>
    user.email.toLowerCase().includes(searchUserQuery.toLowerCase())
  ).sort((a, b) => a.email.localeCompare(b.email));

  const filteredSelectedUser = selectedUser.filter((user) =>
    user.email.toLowerCase().includes(searchUserQuery1.toLowerCase())
  ).sort((a, b) => a.email.localeCompare(b.email));

  const handleDragStartPolicy = (e, item) => {
    e.dataTransfer.setData('text/plain', String(item.id));
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragStartUser = (e, item) => {
    e.dataTransfer.setData('text/plain', String(item.id));
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDropSetPolicy = (e, targetList) => {
    setPolicyListError('')
    e.preventDefault();
    let itemId
    try {
      itemId = Number(e.dataTransfer.getData('text/plain'));
    } catch (error) {
      itemId = Number(e.target.value)
    }
    const draggedPolicy = policy.find((policy) => policy.id === itemId);

    if (draggedPolicy) {
      const updatedPolicy = policy.filter((policy) => policy.id !== itemId);
      const updatedSelectedPolicy = selectedPolicy.filter((policy) => policy.id !== itemId);

      if (targetList === 'available') {
        setPolicy([...updatedPolicy, draggedPolicy]);
        setSelectedPolicy(updatedSelectedPolicy);
      } else if (targetList === 'selected') {
        setPolicy([...updatedPolicy, draggedPolicy]);
        setSelectedPolicy([...updatedSelectedPolicy, draggedPolicy]);
      }
    }
  };

  const handleDropSetUser = (e, targetList) => {
    setUserListError('');
    e.preventDefault();
    let itemId
    try {
      itemId = Number(e.dataTransfer.getData('text/plain'));
    } catch (error) {
      itemId = Number(e.target.value)
    }
    const draggedUser = user.find((user) => user.id === itemId);
  
    if (draggedUser) {
      const updatedUser = user.filter((user) => user.id !== itemId);
      const updatedSelectedUser = selectedUser.filter((User) => User.id !== itemId);
  
      if (targetList === 'available') {
        setUser([...updatedUser, draggedUser]);
        setSelectedUser(updatedSelectedUser);
      } else if (targetList === 'selected') {
        setUser([...updatedUser, draggedUser]);
        setSelectedUser([...updatedSelectedUser, draggedUser]);
      }
    }
  };
  
  const handleGroupName = (event) => {
    setGroupName(event.target.value);
    setGroupNameError('');
  };

  const handleConfirmAction = (event) => {
    setConfirmAction(event.target.value);
    setConfirmActionError("");
  };

  const handleUpdatePopupAsk = () => {
    setSearchPolicyQuery("");
    setSearchPolicyQuery1("");
    setSearchUserQuery("");
    setSearchUserQuery1("");
    if (!groupName) {
      setGroupNameError('Please enter group name');
    }
    if (selectedPolicy.length === 0){
      setPolicyListError('Please select policy')
    }
    if (selectedUser.length === 0){
      setUserListError('Please select user')
    }
    if (!groupName || selectedPolicy.length === 0 || selectedUser.length === 0) {
      return
    }
    setConfirmAction('')
    setConfirmActionError('')
    setPopupTitle("Do you want to change group information")
    setPopupLogo("../assets/app/ask.gif")
    setPopupWidth(80);
    setAskUpdatePopup(true);
    setAskDeletePopup(false);
    setOpen(true);
  }

  const handleDeletePopupAsk = () => {
    setConfirmAction('')
    setConfirmActionError('')
    setPopupTitle("Are you sure, you want to remove group")
    setPopupLogo("../assets/app/ask.gif")
    setPopupWidth(80); 
    setAskUpdatePopup(true);
    setAskDeletePopup(true);
    setOpen(true);
  }

  const handleUpdateGroup = async () => {
    setSearchPolicyQuery("");
    setSearchPolicyQuery1("");
    setSearchUserQuery("");
    setSearchUserQuery1("");
    if(confirmAction !== groupName){
      setConfirmAction('')
      setConfirmActionError('Group name does not match');
      return
    }
    if (!groupName) {
      setGroupNameError('Please enter group name');
    }
    if (selectedPolicy.length === 0){
      setPolicyListError('Please select policy')
    }
    if (selectedUser.length === 0){
      setUserListError('Please select user')
    }
    if (!groupName || selectedPolicy.length === 0 || selectedUser.length === 0) {
      return
    }
    handleClose();
    try {
      setButtonLabel("Loading...");
    
      const policyIds = selectedPolicy.map((item) => item.id);
      const userIds = selectedUser.map((item) => item.id);
      
      const formData = new FormData();
      formData.append("id", group.group.data.id);
      formData.append("name", groupName);
      formData.append("policies", JSON.stringify(policyIds));
      formData.append("users", JSON.stringify(userIds));

      const res = await UpdateGroupMutation({token:getToken(), data:formData });        
      if (res.error) {
        if (res.error.status===400) {
          showToast(false, 'ⓘ', 'Group already exists');
        } else if (res.error.status===500) {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        } else if (res.error.status==="FETCH_ERROR") {
          showToast(false, 'ⓘ', 'Unable to changed group information, server error');
        } else {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        }
      }
      if (res.data) {
        showToast(true, '✔', 'Group information changed');
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setButtonLabel("UPDATE");
      handleClose();
      setAskUpdatePopup(false);
      setAskUpdatePopup(false)
      setConfirmAction('')
      setConfirmActionError('')
    }
  };

  const handleDeleteGroup = async () => {
    if(confirmAction !== groupName){
      setConfirmAction('')
      setConfirmActionError('Group name does not match');
      return
    }
    try {    
      const actualData = {
        id:group.group.data.id,
        token: getToken()
      }
      const res = await DeleteGroupMutation(actualData);

      if (res.error) {
        if (res.error.status===400) {
          showToast(false, 'ⓘ', 'Bad request');
        } else if (res.error.status===500) {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        } else if (res.error.status==="FETCH_ERROR") {
          showToast(false, 'ⓘ', 'Unable to remove group information, server error');
        } else {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        }
      }
      if (res.data) {
        showToast(true, '✔', 'Group information remove');
        setTimeout(() => {
          navigate('/cloud/users', {state:{ dropdownState: 'Group' }});
        }, 3000);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      handleClose();
      setAskUpdatePopup(false);
      setAskUpdatePopup(false)
      setConfirmAction('')
      setConfirmActionError('')
      // setButtonLabel("UPDATE");
    }
  };

  const handleCancel = () => {
    setSearchPolicyQuery("");
    setSearchPolicyQuery1("");
    setSelectedPolicy([]);
    setSearchUserQuery("");
    setSearchUserQuery1("");
    setSelectedUser([]);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setLoading(false);
    try{
      if ( userError || policyError ) {
        if (userError.status === 401 || policyError.status === 401) {
          // showToast(false, 'ⓘ', 'Unauthorized User');
        } else {
          showToast(false, 'ⓘ', 'Something went wrong, server error');
        }
      }
      if (userData && userIsSuccess) {
        setUser(userData.data)
        setSelectedUser(group.group.data.users)
      }
      if (policyData && policyIsSuccess) {
        setPolicy(policyData.data)
        setSelectedPolicy(group.group.data.policies)
      }
      setGroupName(group.group.data.name)
    } catch(error) {
      console.log(error)
    }
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, [ userData, userIsSuccess, policyData, policyIsSuccess ]);

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  return (
    <>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {popupTitle}
        </DialogTitle>
        <DialogContent>
          <Box
            noValidate
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              m: 'auto',
              width: 'fit-content',
            }}
          >
            <img width={popupWidth} src={popupLogo} alt="delete" />
          </Box>
          To confirm action, type group name <strong style={{ color: '#FF2929' }}>{groupName}</strong>
          <FormControl fullWidth>
            <TextField
              autoFocus
              variant="outlined"
              size="small"
              defaultValue={confirmAction}
              onChange={handleConfirmAction}
              helperText={confirmActionError}
              error={Boolean(confirmActionError)}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          {askUpdatePopup?(
            <>
              {askDeletePopup?(
                <Button onClick={() => handleDeleteGroup()}>
                  Yes
                </Button>
              ):(
                <Button onClick={() => handleUpdateGroup()}>
                  Yes
                </Button>
              )}
              <Button onClick={handleClose}>
                No
              </Button>
            </>
          ):(
            <></>
          )}
        </DialogActions>
      </Dialog>
      <Grid item sx={{ width: '250%' }}>
          <FormControl sx={{ mt: 1 }} fullWidth size="small">
            <TextField
              label="Group Name"
              variant="outlined"
              size="small"
              value={groupName}
              onChange={handleGroupName}
              helperText={groupNameError}
              error={Boolean(groupNameError)}
              autoComplete="off"
            />
          </FormControl>

          <Box
              component="form"
              sx={{
              '& .MuiTextField-root': { m: 4, width: '30ch' },
              my: 3,
              }}
              noValidate
              autoComplete="off"
          >
              <List
                name="Policy"
                items={policy}
                selectedItems={selectedPolicy}
                searchQuery={searchPolicyQuery}
                searchQuery1={searchPolicyQuery1}
                handleDragStart={handleDragStartPolicy}
                handleDropItems={handleDropSetPolicy}
                filteredItems={filteredPolicy}
                filteredSelectedItems={filteredSelectedPolicy}
                onSearchQueryChange={(e) => setSearchPolicyQuery(e.target.value)}
                onSearchQuery1Change={(e) => setSearchPolicyQuery1(e.target.value)}
              />
              <Typography style={{ color: '#FF4842', fontSize: '12px', marginLeft: '1%' }}>{policyListError} </Typography>
          </Box>
          
          <Box
              component="form"
              sx={{
              '& .MuiTextField-root': { m: 4, width: '30ch' },
              my: 3,
              }}
              noValidate
              autoComplete="off"
          >
              <List
                name="User"
                items={user}
                selectedItems={selectedUser}
                searchQuery={searchUserQuery}
                searchQuery1={searchUserQuery1}
                handleDragStart={handleDragStartUser}
                handleDropItems={handleDropSetUser}
                filteredItems={filteredUser}
                filteredSelectedItems={filteredSelectedUser}
                onSearchQueryChange={(e) => setSearchUserQuery(e.target.value)}
                onSearchQuery1Change={(e) => setSearchUserQuery1(e.target.value)}
              />
              <Typography style={{ color: '#FF4842', fontSize: '12px', marginLeft: '1%' }}>{userListError}</Typography>
          </Box>

          {group?.group?.data ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Created By Name"
                  value={`${group.group.data.createdBy.first_name} ${group.group.data.createdBy.last_name}`}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Modified By Name"
                  value={`${group.group.data.modifiedBy.first_name} ${group.group.data.modifiedBy.last_name}`}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Created By Email"
                  value={group.group.data.createdBy.email}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Modified By Email"
                  value={group.group.data.modifiedBy.email}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Created On Date"
                  value={formatDate(group.group.data.createdOn)}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} xl={6}>
                <TextField
                  fullWidth
                  disabled
                  id="standard-disabled"
                  label="Modified On Date"
                  value={formatDate(group.group.data.modifiedOn)}
                  variant="outlined"
                  size="small"
                  sx={{ my: 1 }}
                />
              </Grid>
            </Grid>
          ) : (
            <Typography variant="body2">Loading...</Typography>
          )}

          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row-reverse',
                mt: 2
              }}
            >
              <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.5%', xl:'16.5%' }}}>
                <Button
                  onClick={handleCancel}
                  sx={{
                    color: '#9BA4B5',
                    border: 1,
                    borderColor: '#B5C0D0',
                    bgcolor: '#FFF',
                    ":hover": {
                        bgcolor: "#EEEEEE",
                        borderColor: '#EEEEEE',
                    }
                  }}
                  >
                  CLEAR
                </Button>
              </FormControl>
              <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.5%', xl:'16.5%' }}}>
                <Button
                  onClick={() => handleDeletePopupAsk()}
                  sx={{
                    color: '#FFF',
                    border: 1,
                    borderColor: '#E74646',
                    bgcolor: '#E74646',
                    marginRight:2,
                    ":hover": {
                        bgcolor: "#BB2525",
                        borderColor: '#BB2525',
                    }
                  }}>
                  DELETE
                </Button>
              </FormControl>
              <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.4%', xl:'16.4%' }}}>
                <Button
                    onClick={() => handleUpdatePopupAsk()}
                    disabled={buttonLabel==="Loading..."}
                    sx={{
                      color: '#FFF',
                      border: 1,
                      borderColor: '#A8A196',
                      bgcolor: '#A8A196',
                      marginRight:2,
                      ":hover": {
                          bgcolor: "#7D7463",
                          borderColor: '#7D7463',
                      }
                    }}>
                  {buttonLabel}
                </Button>
              </FormControl>
            </Box>
          </Grid> 
      </Grid>
    </>
  );
};
export default Update;
